<div class="dashboard">
  <!-- Actions Bar -->
  <div class="dashboard__actions-bar">
    <div class="dashboard__period-selector">
      <button class="dashboard__period-btn" [class.dashboard__period-btn--active]="selectedPeriod === '7d'" (click)="changePeriod('7d')">7 Tage</button>
      <button class="dashboard__period-btn" [class.dashboard__period-btn--active]="selectedPeriod === '30d'" (click)="changePeriod('30d')">30 Tage</button>
      <button class="dashboard__period-btn" [class.dashboard__period-btn--active]="selectedPeriod === '90d'" (click)="changePeriod('90d')">90 Tage</button>
    </div>
    <button class="dashboard__refresh-btn" (click)="forceRefresh()" [disabled]="loadingSales()">
      <i class="pi" [class.pi-refresh]="!loadingSales()" [class.pi-spin]="loadingSales()" [class.pi-spinner]="loadingSales()"></i>
      <span *ngIf="!loadingSales()">Aktualisieren</span>
      <span *ngIf="loadingSales()">Lädt...</span>
    </button>
  </div>

  <!-- ESG Hero Card -->
  <app-esg-hero
    [score]="esgScore"
    [size]="120"
    [strokeWidth]="10"
    (cardClick)="onEsgHeroClick()"
    (categoryClick)="onEsgCategoryClick($event)"
    class="dashboard__esg-hero">
  </app-esg-hero>

  <!-- KPI Cards Grid -->
  <div class="kpi-grid">
    <!-- Revenue Card -->
    <div class="kpi-card kpi-card--accent">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-chart-line"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingSales() && salesData">
            {{ formatCurrency(salesData.totalRevenue) }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingSales()"></div>
          <div class="kpi-card__label">Umsatz ({{ selectedPeriod }})</div>
        </div>
      </div>
    </div>

    <!-- Orders Card -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-shopping-cart"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingSales() && salesData">
            {{ salesData.totalOrders }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingSales()"></div>
          <div class="kpi-card__label">Bestellungen</div>
        </div>
      </div>
    </div>

    <!-- Profile Visits Card -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-eye"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingEngagement() && engagementData">
            {{ engagementData.profileVisits.total }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingEngagement()"></div>
          <div class="kpi-card__label">Profile Visits</div>
        </div>
      </div>
    </div>

    <!-- SmartCoin Balance Card -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-wallet"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingSmartCoins() && smartCoinOverview">
            {{ formatCurrency(smartCoinOverview.currentBalanceEuros) }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingSmartCoins()"></div>
          <div class="kpi-card__label">SmartCoin Kontostand</div>
        </div>
      </div>
    </div>

    <!-- Achieved Badges Card -->
    <div class="kpi-card kpi-card--accent-orange">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-trophy"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingBadges() && badgeOverview">
            {{ badgeOverview.totalAchieved }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingBadges()"></div>
          <div class="kpi-card__label">Erreichte Badges</div>
        </div>
      </div>
    </div>

    <!-- Average Order Value Card -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-chart-bar"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingSales() && salesData">
            {{ formatCurrency(salesData.averageOrderValue) }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingSales()"></div>
          <div class="kpi-card__label">Ø Bestellwert</div>
        </div>
      </div>
    </div>

    <!-- Unique Visitors Card -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-users"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingEngagement() && engagementData">
            {{ engagementData.uniqueVisitors }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingEngagement()"></div>
          <div class="kpi-card__label">Unique Sessions</div>
        </div>
      </div>
    </div>

    <!-- Badge Bonus Paid Card -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-gift"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingBadges() && badgeOverview">
            {{ formatCurrency(badgeOverview.totalBonusPaid / 100) }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingBadges()"></div>
          <div class="kpi-card__label">Badge Boni ausgezahlt</div>
        </div>
      </div>
    </div>

    <!-- Donations Card - Only for e.V. -->
    <div class="kpi-card" *ngIf="isDonationHub">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-heart"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingDonations() && donationChartData">
            {{ formatCurrency(donationChartData.totalAmountInEuros) }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingDonations()"></div>
          <div class="kpi-card__label">Spenden erhalten</div>
        </div>
      </div>
    </div>

    <!-- Posts Card -->
    <div class="kpi-card">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-image"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingPosts() && postStats">
            {{ postStats.total_posts }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingPosts()"></div>
          <div class="kpi-card__label" *ngIf="!loadingPosts() && postStats">
            Posts ({{ postStats.engagement_rate.toFixed(1) }}% Engagement)
          </div>
          <div class="kpi-card__label" *ngIf="loadingPosts()">Posts</div>
        </div>
      </div>
    </div>

    <!-- Tickets Sold Card -->
    <div class="kpi-card kpi-card--clickable" *ngIf="ticketAnalytics && ticketAnalytics.totalSold > 0" (click)="goToTickets()">
      <div class="kpi-card__header">
        <div class="kpi-card__icon">
          <i class="pi pi-ticket"></i>
        </div>
        <div class="kpi-card__content">
          <div class="kpi-card__value" *ngIf="!loadingTickets()">
            {{ ticketAnalytics.totalSold }}
          </div>
          <div class="kpi-card__skeleton" *ngIf="loadingTickets()"></div>
          <div class="kpi-card__label">Tickets verkauft</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Charts Section -->
  <div class="chart-grid">
    <!-- Revenue Chart -->
    <div class="chart-card">
      <div class="chart-card__header">
        <h3 class="chart-card__title">Umsatz ({{ selectedPeriod }})</h3>
      </div>
      <div class="chart-card__body">
        <div class="chart-card__empty" *ngIf="!loadingSales() && salesData && salesData.totalRevenue === 0">
          <div class="chart-card__empty-icon">
            <i class="pi pi-chart-line"></i>
          </div>
          <div class="chart-card__empty-text">Keine Umsatzdaten verfügbar</div>
          <div class="chart-card__empty-subtext">Daten erscheinen nach ersten Verkäufen</div>
        </div>
        <canvas #revenueChart></canvas>
      </div>
    </div>

    <!-- SmartCoin Balance Chart -->
    <div class="chart-card">
      <div class="chart-card__header">
        <h3 class="chart-card__title">SmartCoin Kontostand</h3>
      </div>
      <div class="chart-card__body">
        <div class="chart-card__empty" *ngIf="!loadingSmartCoinChart() && smartCoinChartData && smartCoinChartData.historical.length === 0">
          <div class="chart-card__empty-icon">
            <i class="pi pi-wallet"></i>
          </div>
          <div class="chart-card__empty-text">Keine SmartCoin Daten verfügbar</div>
          <div class="chart-card__empty-subtext">Transaktionen erscheinen hier</div>
        </div>
        <canvas #smartCoinBalanceChart></canvas>
      </div>
    </div>

    <!-- SmartCoin Flow Chart -->
    <div class="chart-card">
      <div class="chart-card__header">
        <h3 class="chart-card__title">SmartCoin Bewegungen</h3>
      </div>
      <div class="chart-card__body">
        <div class="chart-card__empty" *ngIf="!loadingSmartCoinChart() && smartCoinChartData && smartCoinChartData.historical.length === 0">
          <div class="chart-card__empty-icon">
            <i class="pi pi-arrows-h"></i>
          </div>
          <div class="chart-card__empty-text">Keine Bewegungen</div>
          <div class="chart-card__empty-subtext">Transaktionen erscheinen hier</div>
        </div>
        <canvas #smartCoinFlowChart></canvas>
      </div>
    </div>

    <!-- Engagement Chart -->
    <div class="chart-card">
      <div class="chart-card__header">
        <h3 class="chart-card__title">Engagement Events</h3>
      </div>
      <div class="chart-card__body">
        <div class="chart-card__empty" *ngIf="!loadingEngagement() && engagementData && engagementData.profileVisits.total === 0">
          <div class="chart-card__empty-icon">
            <i class="pi pi-chart-bar"></i>
          </div>
          <div class="chart-card__empty-text">Kein Engagement</div>
          <div class="chart-card__empty-subtext">Warte auf erste Besucher</div>
        </div>
        <canvas #engagementChart></canvas>
      </div>
    </div>

    <!-- Session Duration Chart -->
    <div class="chart-card">
      <div class="chart-card__header">
        <h3 class="chart-card__title">Session Verweildauer</h3>
      </div>
      <div class="chart-card__body">
        <div class="chart-card__empty" *ngIf="!loadingEngagement() && engagementData && engagementData.sessionDurationDistribution.length === 0">
          <div class="chart-card__empty-icon">
            <i class="pi pi-clock"></i>
          </div>
          <div class="chart-card__empty-text">Keine Session-Daten</div>
          <div class="chart-card__empty-subtext">Daten erscheinen nach Sessions</div>
        </div>
        <canvas #sessionDurationChart></canvas>
      </div>
    </div>

    <!-- Donation Chart - Only for e.V. -->
    <div class="chart-card" *ngIf="isDonationHub">
      <div class="chart-card__header">
        <h3 class="chart-card__title">Spenden ({{ selectedPeriod }})</h3>
        <div class="chart-card__meta" *ngIf="!loadingDonations() && donationChartData">
          <div class="chart-card__meta-item">
            <div class="chart-card__meta-label">Ø Spende</div>
            <div class="chart-card__meta-value">{{ formatCurrency(donationChartData.averageDonationInEuros) }}</div>
          </div>
          <div class="chart-card__meta-item">
            <div class="chart-card__meta-label">Spender</div>
            <div class="chart-card__meta-value">{{ donationChartData.totalDonors }}</div>
          </div>
        </div>
      </div>
      <div class="chart-card__body">
        <div class="chart-card__loading" *ngIf="loadingDonations()">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
        <canvas #donationChart *ngIf="!loadingDonations() && donationChartData && donationChartData.historical.length > 0"></canvas>
        <div class="chart-card__empty" *ngIf="!loadingDonations() && donationChartData && donationChartData.historical.length === 0">
          <div class="chart-card__empty-icon">
            <i class="pi pi-heart"></i>
          </div>
          <div class="chart-card__empty-text">Noch keine Spenden erhalten</div>
        </div>
      </div>
    </div>

    <!-- Funnel Chart -->
    <div class="chart-card chart-card--wide">
      <div class="chart-card__header">
        <h3 class="chart-card__title">Conversion Funnel</h3>
      </div>
      <div class="chart-card__body">
        <div class="chart-card__empty" *ngIf="!loadingEngagement() && engagementData && engagementData.profileVisits.total === 0">
          <div class="chart-card__empty-icon">
            <i class="pi pi-filter"></i>
          </div>
          <div class="chart-card__empty-text">Keine Funnel-Daten</div>
          <div class="chart-card__empty-subtext">Erscheint nach ersten Besuchern</div>
        </div>
        <canvas #funnelChart></canvas>
      </div>
    </div>
  </div>

  <!-- List Cards Section -->
  <div class="list-grid">
    <!-- Top Products -->
    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Top Produkte</h3>
        <button class="list-card__action" (click)="goToProducts()">
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
      <div class="list-card__body" *ngIf="!loadingTopProducts() && topProducts.length > 0">
        <div class="list-card__item" *ngFor="let product of topProducts" (click)="viewProduct(product)">
          <div class="list-card__avatar">
            <i class="pi pi-box"></i>
          </div>
          <div class="list-card__info">
            <div class="list-card__name">{{ product.name }}</div>
            <div class="list-card__meta">
              <i class="pi pi-shopping-bag"></i>
              {{ product.totalQuantity }} verkauft
            </div>
          </div>
          <div class="list-card__amount">{{ formatCurrency(product.revenue) }}</div>
        </div>
      </div>
      <div class="list-card__empty" *ngIf="!loadingTopProducts() && topProducts.length === 0">
        <i class="pi pi-inbox"></i>
        <p>Keine Verkäufe</p>
        <span>Produkte erscheinen nach Verkäufen</span>
      </div>
    </div>

    <!-- Recent Orders -->
    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Neueste Bestellungen</h3>
        <button class="list-card__action" (click)="goToOrders()">
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
      <div class="list-card__body" *ngIf="!loadingRecentOrders() && recentOrders.length > 0">
        <div class="list-card__item" *ngFor="let order of recentOrders" (click)="viewOrder(order)">
          <div class="list-card__info">
            <div class="list-card__name">#{{ order.orderNumber }}</div>
            <div class="list-card__meta">{{ order.customerName }}</div>
          </div>
          <div class="list-card__amount">{{ formatCurrency(order.totalPrice) }}</div>
          <span class="list-card__badge"
            [class.list-card__badge--pending]="order.status === 'pending'"
            [class.list-card__badge--completed]="order.status === 'completed'"
            [class.list-card__badge--cancelled]="order.status === 'cancelled'"
            [class.list-card__badge--shipped]="order.status === 'shipped'">
            {{ order.status }}
          </span>
        </div>
      </div>
      <div class="list-card__empty" *ngIf="!loadingRecentOrders() && recentOrders.length === 0">
        <i class="pi pi-inbox"></i>
        <p>Keine Bestellungen</p>
        <span>Bestellungen erscheinen hier</span>
      </div>
    </div>

    <!-- Top Badge Earners -->
    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Top Badge Sammler</h3>
        <button class="list-card__action" (click)="goToBadges()">
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
      <div class="list-card__body" *ngIf="!loadingTopBadgeEarners() && topBadgeEarners && topBadgeEarners.users.length > 0">
        <div class="list-card__item" *ngFor="let user of topBadgeEarners.users; let i = index">
          <div class="list-card__rank"
            [class.list-card__rank--1]="i === 0"
            [class.list-card__rank--2]="i === 1"
            [class.list-card__rank--3]="i === 2"
            [class.list-card__rank--default]="i > 2">
            #{{ i + 1 }}
          </div>
          <div class="list-card__info">
            <div class="list-card__name">{{ user.userName }}</div>
            <div class="list-card__meta">
              <span><i class="pi pi-trophy"></i> {{ user.achievedBadges }}/{{ user.totalBadges }}</span>
              <span><i class="pi pi-gift"></i> {{ formatCurrency(user.totalBonusEarned / 100) }}</span>
            </div>
          </div>
          <div class="list-card__amount">{{ user.achievementRate.toFixed(1) }}%</div>
        </div>
      </div>
      <div class="list-card__empty" *ngIf="!loadingTopBadgeEarners() || !topBadgeEarners || topBadgeEarners.users.length === 0">
        <i class="pi pi-trophy"></i>
        <p>Keine Badges</p>
        <span>Erstelle Badge-Konfigs</span>
      </div>
    </div>
  </div>

  <!-- Badge Section -->
  <div class="badge-grid">
    <!-- Active Badge Configs -->
    <div class="badge-config-card">
      <div class="badge-config-card__header">
        <h4 class="badge-config-card__title">Aktive Badge Konfigs</h4>
        <button class="badge-config-card__action" (click)="goToBadges()">Alle anzeigen</button>
      </div>
      <div class="badge-config-card__list" *ngIf="!loadingBadgeConfigs() && badgeConfigs.length > 0">
        <div class="badge-config-card__item" *ngFor="let config of badgeConfigs" (click)="goToBadges()">
          <div class="badge-config-card__icon" [style.background-color]="config.badgeColor + '20'">
            <i [class]="'pi ' + config.badgeIcon" [style.color]="config.badgeColor"></i>
          </div>
          <div class="badge-config-card__info">
            <div class="badge-config-card__name">{{ config.badgeName }}</div>
            <div class="badge-config-card__meta">
              {{ config.stats?.achievedCount || 0 }} erreicht · {{ config.stats?.totalUsers || 0 }} Nutzer
            </div>
          </div>
          <div class="badge-config-card__stats">
            <div class="badge-config-card__rate">{{ config.stats?.achievementRate || 0 }}%</div>
            <div class="badge-config-card__rate-label">Quote</div>
          </div>
        </div>
      </div>
      <div class="badge-config-card__empty" *ngIf="!loadingBadgeConfigs() && badgeConfigs.length === 0">
        <i class="pi pi-inbox"></i>
        <p>Keine Badge Konfigs</p>
        <span>Erstelle deine erste Badge-Konfiguration</span>
      </div>
      <div class="kpi-card__skeleton kpi-card__skeleton--tall" *ngIf="loadingBadgeConfigs()"></div>
    </div>

    <!-- Badge Health Score -->
    <div class="badge-health-card">
      <h4 class="badge-health-card__title">Badge Health</h4>
      <div *ngIf="!loadingBadges() && badgeOverview && badgeOverview.totalUsers > 0">
        <div class="badge-health-card__chart">
          <div class="badge-health-card__ring">
            <div class="badge-health-card__ring-bg"
              [class.health--excellent]="calculateBadgeHealth() >= 80"
              [class.health--good]="calculateBadgeHealth() >= 60 && calculateBadgeHealth() < 80"
              [class.health--fair]="calculateBadgeHealth() >= 40 && calculateBadgeHealth() < 60"
              [class.health--poor]="calculateBadgeHealth() < 40">
              <div class="badge-health-card__ring-inner">
                <span class="badge-health-card__score"
                  [class.health--excellent]="calculateBadgeHealth() >= 80"
                  [class.health--good]="calculateBadgeHealth() >= 60 && calculateBadgeHealth() < 80"
                  [class.health--fair]="calculateBadgeHealth() >= 40 && calculateBadgeHealth() < 60"
                  [class.health--poor]="calculateBadgeHealth() < 40">
                  {{ calculateBadgeHealth() }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="badge-health-card__stats">
          <div class="badge-health-card__stat">
            <span class="badge-health-card__stat-label">Erreichungsquote:</span>
            <span class="badge-health-card__stat-value">{{ badgeOverview.achievementRate.toFixed(1) }}%</span>
          </div>
          <div class="badge-health-card__stat">
            <span class="badge-health-card__stat-label">Total Badges:</span>
            <span class="badge-health-card__stat-value">{{ badgeOverview.totalBadges }}</span>
          </div>
          <div class="badge-health-card__stat">
            <span class="badge-health-card__stat-label">Erreicht:</span>
            <span class="badge-health-card__stat-value">{{ badgeOverview.totalAchieved }}</span>
          </div>
        </div>
      </div>
      <div class="badge-health-card__empty" *ngIf="!loadingBadges() && badgeOverview && badgeOverview.totalUsers === 0">
        <i class="pi pi-chart-pie"></i>
        <p>Keine Badge-Daten</p>
        <span>Health Score erscheint mit ersten Nutzern</span>
      </div>
      <div class="kpi-card__skeleton kpi-card__skeleton--tall" *ngIf="loadingBadges()"></div>
    </div>
  </div>

  <!-- Summary Cards -->
  <div class="summary-grid">
    <!-- Engagement Summary -->
    <div class="summary-card">
      <h4 class="summary-card__title">Engagement</h4>
      <div class="summary-card__list" *ngIf="!loadingEngagement() && engagementData">
        <div class="summary-card__row">
          <span class="summary-card__label">Add-to-Cart:</span>
          <span class="summary-card__value">{{ engagementData.addToCartRate.toFixed(1) }}%</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Ø Session:</span>
          <span class="summary-card__value">{{ formatDuration(engagementData.averageSessionDuration) }}</span>
        </div>
      </div>
    </div>

    <!-- SmartCoins Summary -->
    <div class="summary-card">
      <h4 class="summary-card__title">
        <i class="pi pi-wallet"></i>
        SmartCoins
      </h4>
      <div class="summary-card__list" *ngIf="!loadingSmartCoins() && smartCoinOverview">
        <div class="summary-card__row">
          <span class="summary-card__label">Netto:</span>
          <span class="summary-card__value"
            [class.summary-card__value--green]="smartCoinOverview.netChangeEuros >= 0"
            [class.summary-card__value--red]="smartCoinOverview.netChangeEuros < 0">
            {{ formatCurrency(smartCoinOverview.netChangeEuros) }}
          </span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Ausgegeben:</span>
          <span class="summary-card__value">{{ formatCurrency(smartCoinOverview.totalSpentEuros) }}</span>
        </div>
      </div>
    </div>

    <!-- Sales Summary or Donation Summary -->
    <div class="summary-card" *ngIf="!isDonationHub">
      <h4 class="summary-card__title">Sales</h4>
      <div class="summary-card__list" *ngIf="!loadingSales() && salesData">
        <div class="summary-card__row">
          <span class="summary-card__label">Conversion:</span>
          <span class="summary-card__value">{{ salesData.conversionRate.toFixed(2) }}%</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Ø Order:</span>
          <span class="summary-card__value">{{ formatCurrency(salesData.averageOrderValue) }}</span>
        </div>
      </div>
    </div>

    <!-- Donation Summary - Only for e.V. -->
    <div class="summary-card" *ngIf="isDonationHub">
      <h4 class="summary-card__title">
        <i class="pi pi-heart"></i>
        Spenden
      </h4>
      <div class="summary-card__list" *ngIf="!loadingDonations() && donationChartData">
        <div class="summary-card__row">
          <span class="summary-card__label">Gesamt:</span>
          <span class="summary-card__value">{{ formatCurrency(donationChartData.totalAmountInEuros) }}</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Ø Spende:</span>
          <span class="summary-card__value">{{ formatCurrency(donationChartData.averageDonationInEuros) }}</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label">Spender:</span>
          <span class="summary-card__value">{{ donationChartData.totalDonors }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Error State -->
  <div class="error-alert" *ngIf="hasError()">
    <app-alert
      severity="error"
      title="Daten konnten nicht geladen werden"
      message="Bitte überprüfe deine Verbindung und versuche es erneut."
      icon="pi pi-wifi"
      [showActions]="true">
      <div alert-actions>
        <button class="error-alert__button" (click)="forceRefresh()">
          <i class="pi pi-refresh"></i>
          Erneut versuchen
        </button>
      </div>
    </app-alert>
  </div>
</div>
